<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'
import { useI18n } from 'vue-i18n'

const emit = defineEmits<{
  openImpersonate: []
}>()

const { t } = useI18n()
</script>

<template>
  <div class="my-wallet-not-impersonate">
    <img src="/images/not-impersonate-overview.svg" alt="" class="my-wallet-not-impersonate-image">
    <div class="my-wallet-not-impersonate-text">
      <h3 class="my-wallet-not-impersonate-title">
        {{ t('my_wallet.not_impersonate.title') }}
      </h3>
      <p class="my-wallet-not-impersonate-description">
        {{ t('my_wallet.not_impersonate.description') }}
      </p>
    </div>
    <SolButton id="my-wallet-view-as-partner" @click="emit('openImpersonate')">
      {{ t('my_wallet.not_impersonate.button') }}
    </SolButton>
  </div>
</template>

<style scoped lang="scss">
.my-wallet-not-impersonate {
  @apply flex flex-col items-center gap-6 py-8 mx-auto text-center;
  max-width: 550px;

  .my-wallet-not-impersonate-image {
    @apply w-full h-auto;
    max-width: 105px;
  }

  .my-wallet-not-impersonate-text {
    @apply flex flex-col gap-2;
  }

  .my-wallet-not-impersonate-title {
    @apply fonts-heading-h4 text-neutral-low-pure;
  }

  .my-wallet-not-impersonate-description {
    @apply fonts-body-large-regular text-neutral-low-light;
  }
}
</style>
